import { ReactNode, useEffect, useState } from "react";
import { ILead } from "../../../../types/lead.type";
import { getLeadById, updateLead } from "../../../../common/services/leads.api";
import { initialState, LeadDashboardContext } from "./LeadDashboard.context";

type Props = {
  children: ReactNode,
  leadId: string
}

export function LeadDashboardProvider(props: Props) {

  const [lead, setLead] = useState<ILead>(initialState.lead)

  useEffect(() => {
    async function loadLead(leadId: string) {
      const result = await getLeadById(leadId)

      if (result.ok) {
        setLead(result.data as ILead)
      }
    }

    loadLead(props.leadId)
  }, [props.leadId])

  async function saveLead(dataToSave: ILead) {
    try {
      const { ok, data, errors } = await updateLead(lead._id as string, dataToSave)

      if (ok && data) {
        setLead(data as ILead)
        return { ok, data: data as ILead, errors: (errors as [{ message: string, path: string[] }]) }
      }

      return { ok, data: data as ILead, errors: errors as [{ message: string, path: string[] }] }
    } catch (err) {
      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }]
      }
    }
  }

  const theState = { lead, saveLead }

  return (
    <LeadDashboardContext.Provider value={theState}>
      {props.children}
    </LeadDashboardContext.Provider>
  )
}